module.exports = __webpack_public_path__ + "images/10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/babel/10.jpg
// module id = 48
// module chunks = 0